import { createFileRoute } from '@tanstack/react-router';
import { BenefitCatalogNewPage } from './BenefitCatalogNewPage';

export const Route = createFileRoute('/_protected/admin/internal-tools/benefit-catalog/new/')({
  component: BenefitCatalogNewPage,
});
